import DapDSSelect from './select.component'

export * from './select.component'
export default DapDSSelect

DapDSSelect.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-select': DapDSSelect
  }
}
